import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'; // Import icons from react-icons
import '../styles/LawDisplayPage.css';

const CriminalLaw = () => {
  const navigate = useNavigate();
  const buttonContainerRef = useRef(null);

  const scrollLeft = () => {
    buttonContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    buttonContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    <div className="law-page">
      {/* Heading */}
      <h1>Indian Criminal Law</h1>

      {/* Details of New Criminal Law Acts (2024) */}
      <div className="content-section">
        <h2>Details of New Criminal Law Acts (2024)</h2>
        <p>
          As of July 1, 2024, India's criminal law is divided into three new acts:
          <ul>
            <li><strong>Bharatiya Nyaya Sanhita (BNS):</strong> Replaces the Indian Penal Code (IPC) of 1860</li>
            <li><strong>Bharatiya Nagarik Suraksha Sanhita (BNSS):</strong> Replaces the Code of Criminal Procedure (CrPC) of 1973</li>
            <li><strong>Bharatiya Sakshya Adhiniyam (BSA):</strong> Replaces the Indian Evidence Act of 1872</li>
          </ul>
          The new laws make changes to the criminal justice system at several levels, including substantive crimes, police investigations, judicial magistrates, and trials.
        </p>
      </div>

      {/* Horizontal Scrollable Buttons with Left/Right Arrows */}
      <div className="scroll-wrapper">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={scrollLeft} />
        <div className="button-container" ref={buttonContainerRef}>
          <button className="big-button">
            <div className="button-text">
              Bharatiya Nyaya Sanhita
              <span>(BNS) (IPC)</span>
            </div>
          </button>
          <button className="big-button">
            <div className="button-text">
              Bharatiya Nagarik Suraksha
              <span>Sanhita (BNSS) (CrPc)</span>
            </div>
          </button>
          <button className="big-button">
            <div className="button-text">
              Bharatiya Sakshya Adhiniyam
              <span>(BSA) (IEA)</span>
            </div>
          </button>
          <button className="big-button" onClick={() => navigate('/search')}>
            <div className="button-text">
              Search area
            </div>
          </button>
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={scrollRight} />
      </div>
    </div>
  );
};

export default CriminalLaw;
